import { Button } from '@mui/material';
import React from 'react';

import i18n from 'FRONTEND/utils/i18n';

const CenterMapButton = () => {
  return (
    <Button className='actionbar-menuButton' variant='contained' sx={{ mt: 2, borderRadius: (theme) => theme.spacing(3) }}>
      {i18n._('Reset current center and zoom')}
    </Button>

  );
};

export default CenterMapButton;
